const MIN_ANIMATION_MS = 10_000;
const POLL_INTERVAL_MS = 2000;
const POLL_DEADLINE_MS = 90_000;

// Wakes an idle self-hosted tenant's containers and resolves once it's live,
// padding the wait to MIN_ANIMATION_MS so the waking overlay never flashes.
export async function wakeTenantAndWait(tenantId: string): Promise<void> {
  const start = Date.now();

  const res = await fetch('/api/auth/wake-tenant', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ tenantId }),
  });
  const data = await res.json();

  if (!res.ok && !data.triggered) {
    throw new Error(data.error || 'Failed to wake tenant');
  }

  if (data.triggered || data.success !== true) {
    const deadline = Date.now() + POLL_DEADLINE_MS;
    let isLive = false;
    while (Date.now() < deadline) {
      await new Promise((r) => setTimeout(r, POLL_INTERVAL_MS));
      const statusRes = await fetch(
        `/api/auth/tenant-status?tenantId=${encodeURIComponent(tenantId)}`,
      );
      const status = await statusRes.json();
      if (status.is_live === 'live') {
        isLive = true;
        break;
      }
    }
    if (!isLive) {
      throw new Error('Tenant did not wake up in time');
    }
  }

  const elapsed = Date.now() - start;
  if (elapsed < MIN_ANIMATION_MS) {
    await new Promise((r) => setTimeout(r, MIN_ANIMATION_MS - elapsed));
  }
}
